<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    :visible.sync="abnormalVisible"
    title="绑定异常处理"
    :width="'824px'"
    :append-to-body="true"
    :before-close="cancelHandle"
    @open="handleInitial"
  >
    <div class="company">
      <div>租赁方案所属公司:</div>
      <div>{{ userInfo.tenantName }}</div>
    </div>
    <div class="abnormal_tips">
      <div>如下租赁方案已绑定了不同的维保项目，请选择处理方案</div>
      <div>
        覆盖更新：会删除已绑定的维保项目使用新维保项目，不影响已创建的企业/个人租赁订单
      </div>
      <div>
        添加：在已绑定维保项目基础上，增加新的维保项目，不影响已创建的企业/个人租赁订单
      </div>
      <div>不处理:保持已绑定维保项目不变</div>
    </div>
    <el-table width="80%" :data="tableData" style="width: 100%">
      <el-table-column
        v-for="(item, index) in this.abnormalData.get(this.bindType).columns"
        :key="index"
        :prop="item.columnProps.prop"
        :label="item.columnProps.label"
      >
      </el-table-column>

      <el-table-column label="操作" width="270">
        <!-- eslint-disable-next-line vue/no-unused-vars -->
        <template slot="header" slot-scope="scope">
          <div style="text-align: center">处理方式</div>
          <el-radio-group
            :value="batchRadio"
            @input="handleBatchChange($event)"
          >
            <el-radio
              :label="item.label"
              v-for="item in radioArr"
              :key="+item.label"
              >{{ item.text }}</el-radio
            >
          </el-radio-group>
        </template>
        <template slot-scope="scope">
          <el-radio-group
            :value="scope.row.handleWay"
            @input="handleRadioChange($event, scope.row)"
          >
            <el-radio
              :label="item.label"
              v-for="item in radioArr"
              :key="+item.label"
              >{{ item.text }}</el-radio
            >
          </el-radio-group>
        </template>
      </el-table-column>
    </el-table>

    <div slot="footer">
      <div class="mt16" style="text-align: center">
        <el-button size="small" @click="cancelHandle">取消</el-button>
        <el-button type="primary" size="small" :loading="loading" @click="handleOK"
          >确认</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import schemeConfig from './bindSchemeDialog/config'
import { createBindrecordApi } from '../services'
import { mapGetters } from 'vuex'

export default {
  name: 'abnormalDialog',
  props: {
    abnormalVisible: {
      type: Boolean,
      default: false,
    },
    abnormalData: {
      type: Map,
      default: () => new Map(),
    },
    id: {
      type: [Number, String],
    },
    bindType: {
      type: String,
      default: 'scheme',
    },
  },
  data() {
    const { radioArr } = schemeConfig.call(this)
    return {
      loading: false,
      radioArr,
      batchRadio: 2,
      tableData: [],
      rentPlans: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    handleInitial() {
      if (!this.abnormalData.get(this.bindType)) return
      this.tableData = JSON.parse(
        JSON.stringify(this.abnormalData.get(this.bindType).data),
      )
      this.tableData = this.tableData.map((item) => {
        this.$set(item, 'handleWay', this.batchRadio)
        return item
      })
      let IdType = ''
      if (this.bindType === 'scheme') {
        IdType = 'rentPlanId'
      } else {
        IdType = 'orderId'
      }

      this.rentPlans = this.tableData.map((item) => ({
        id: item[IdType],
        handleWay: 2,
        accountId: item.accountId,
      }))
    },
    cancelHandle() {
      this.tableData = []
      this.rentPlans = []
      this.batchRadio = 2
      this.$emit('close')
    },
    handleOK() {
      let IdType = ''
      if (this.bindType === 'scheme') {
        IdType = 'rentPlanId'
      } else {
        IdType = 'orderId'
      }

      const _list = []
      let bStop = false
      for (let i = 0; i < this.tableData.length; i++) {
        for (let j = 0; j < this.rentPlans.length; j++) {
          if (this.tableData[i][IdType] === this.rentPlans[j].id) {
            bStop = true
          }
        }
        if (!bStop) {
          _list.push({
            id: this.tableData[i][IdType],
            handleWay: 2,
            accountId: this.tableData[i].accountId,
          })
        }
      }

      this.createBindrecord({
        itemId: this.id,
        idAndHandelWays: this.rentPlans.concat(_list),
      })
    },
    // 单个处理
    handleRadioChange(e, row) {
      let IdType = ''
      if (this.bindType === 'scheme') {
        IdType = 'rentPlanId'
      } else {
        IdType = 'orderId'
      }

      const index = this.tableData.findIndex(
        (item) => item[IdType] === row[IdType],
      )
      if (this.batchRadio !== '') {
        this.batchRadio = ''
      }

      if (index !== -1) {
        this.tableData[index].handleWay = e
      }

      const idx = this.rentPlans.findIndex(
        (item) => item.id === this.tableData[index][IdType],
      )
      if (idx === -1) {
        this.rentPlans.push({
          id: this.tableData[index][IdType],
          handleWay: e,
          accountId: this.tableData[index].accountId,
        })
      } else {
        this.rentPlans[idx].handleWay = e
      }
    },
    // 批量处理
    handleBatchChange(e) {
      this.batchRadio = e
      let IdType = ''
      if (this.bindType === 'scheme') {
        IdType = 'rentPlanId'
      } else {
        IdType = 'orderId'
      }
      this.tableData = this.tableData.map((item) => ({
        ...item,
        handleWay: this.batchRadio,
      }))

      this.rentPlans = this.tableData.map((item) => {
        return {
          id: item[IdType],
          handleWay: this.batchRadio,
          accountId: item.accountId,
        }
      })
    },
    async createBindrecord(params) {
      if (this.loading) return
      this.loading = true
      const createBindrecordFn = createBindrecordApi.get(this.bindType)
      const [err, _data] = await this.$to(createBindrecordFn({ ...params }))
      if (!err) {
        const { code } = _data
        if (code === 1) {
          this.cancelHandle()
          this.$message.success('操作成功')
        }
      }
      // 为了让二次弹窗成功
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.company {
  display: flex;
  font-size: 14px;
  & > div:nth-child(1) {
    font-weight: 500;
    margin-right: 10px;
  }
}

.abnormal_tips {
  margin-top: 10px;
  margin-bottom: 15px;
  & > div:nth-child(1) {
    font-size: 14px;
    font-weight: 500;
  }
  & > div:nth-child(2),
  & > div:nth-child(3),
  & > div:nth-child(4) {
    font-size: 12px;
    color: #333;
    margin-top: 5px;
  }
}
</style>
